import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OPD_API_URL } from '../../properties/opd-url-properties';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';

@Component({
  selector: 'app-confirm-checkout',
  templateUrl: './confirm-checkout.component.html',
  styleUrls: ['./confirm-checkout.component.scss']
})
export class ConfirmCheckoutComponent implements OnInit ,OnDestroy{

  constructor(    
    private appBaseService: AppBaseService,
    public dialogRef: MatDialogRef<ConfirmCheckoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    ) { }

  ngOnInit(): void {

  }
  ngOnDestroy(): void {
    
  }
  confirmCheckout(){
    let payload={
      remarks:this.data.remark,
      status:"CHO",
    }
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
      this.appBaseService
        .putResource(
          OPD_API_URL.UPDATE_ENQ_STATUS +this.data.id,payload)
        .subscribe((res) => {
          if(res.id){
            this.snackBar.open(
              "Checkout the Patient","success",{duration: 1000,}
            );
            this.dialogRef.close();
          }
        })

  }
  onClose(){
    this.dialogRef.close();
  }
}
